export default {
  buyRow1: '杰为工业软件助力技术堆栈的高效重建，优先选取您需要的数字化能力，新应用与现有系统同时运行，根据需要进行部署或改进，轻松便捷。',
  buyRow2: '',
  buyRow3: '',
  buyRow4: '点击注册，免费试用',
  buyRow5: '',
  buyRow6: '在交互式的非生产环境中',
  buyRow7: '点击即验证杰为工业软件的功能',
  buyRow8: '感受你想象中的数字化转型',
  buyRow9: '创建帐户，体验首个真正意义上的实时数字化链。',
  buyRow10: '揭秘杰为的世界，在这里，我们助您改善协作，更快输出优质决策。',
  buyRow11: '以下产品可免费试用',
  buyRow12: 'Digital PLM',
  buyRow13: 'Digital PQM',
  buyRow14: 'Device Mate',
  buyRow15: '',
  buyRow16: '',
  buyRow17: '注册',
  buyRow18: '公司名称',
  buyRow19: '用户姓名',
  buyRow20: '手机',
  buyRow21: '验证码',
  buyRow22: '获取验证码',
  buyRow23: '我同意杰为服务条款、隐私协议',
  buyRow24: '杰为工业云'
}
